"use client";

import { cn } from "@watt/ui/utils/classname-tailwind-merge";
import { useVerification } from "./verification-context";

export interface VerificationErrorProps {
  className?: string;
}

export function VerificationError({ className }: VerificationErrorProps) {
  const { state } = useVerification();

  if (!state.error) {
    return null;
  }

  return (
    <p className={cn("font-medium text-destructive text-sm", className)}>
      {state.error}
    </p>
  );
}
